export const localStorageKeys = {
  ACCESS_TOKEN: 'bitlab:accessToken',
};
